import { Directive, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputComponent } from '../components/input/input.component';

@Directive({
	selector: '[formControlName][name="orgNumber"]',
	standalone: false,
})
export class OrgNumberMaskDirective implements OnInit {
	constructor(public ngControl: NgControl, private inputComponent: InputComponent) {}

	@HostListener('input', ['$event'])
	onChange(event) {
		this.onInputChange(event.target.value);
	}

	ngOnInit(): void {
		this.onInputChange(this.ngControl.value);
	}

	sanitize(value: string) {
		if (!value) return null;

		return value.replace('-', '');
	}

	mask(value: string) {
		if (!value) return null;

		let newValue = value;

		const raw = newValue.replace('-', '');

		// Don't try to format if the input is too short
		if (raw.length < 10) return newValue;

		const formatted = `${raw.slice(0, 6)}-${raw.slice(6)}`;

		if (newValue !== formatted) {
			newValue = formatted;
		}

		return newValue;
	}

	onInputChange(value: string) {
		const maskedValue = this.mask(value);
		this.inputComponent.writeValue(maskedValue);
		this.inputComponent.onChanged(this.sanitize(maskedValue));
	}
}
